export enum RecipientStatusType {
    Sent = 'Sent',
    Viewed = 'Viewed',
    Signed = 'Signed',
    Declined = 'Declined',
    Caution = "Caution",
    HighRisk = "HighRisk",
    Draft = "Draft",
    WaitingForOthers = "WaitingForOthers",
    ManualReview= "ManualReview",
    Started = "Started"
}

const recipientStatusNumericMap: Record<number, RecipientStatusType> = {
    0: RecipientStatusType.Sent,
    1: RecipientStatusType.Viewed,
    2: RecipientStatusType.Signed,
    3: RecipientStatusType.Declined,
    4: RecipientStatusType.Caution,
    5: RecipientStatusType.HighRisk,
    6: RecipientStatusType.Draft,
    7: RecipientStatusType.WaitingForOthers,
    8: RecipientStatusType.ManualReview,
    9: RecipientStatusType.Started,
};

export function resolveRecipientStatus(value: string | number): RecipientStatusType {
    if (typeof value === 'number') {
        return recipientStatusNumericMap[value];
    }
    return value as RecipientStatusType;
}
